<template>
    <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_549_8016)">
            <rect width="36" height="36" fill="none" />
            <circle
                cx="18"
                cy="18"
                r="18"
                fill="#F2F0F0"
                class="fill-transparent hover:cursor-pointer hover:fill-gray-300"
            />
            <path
                d="M18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19Z"
                stroke="#A6A6A6"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M18 12C18.5523 12 19 11.5523 19 11C19 10.4477 18.5523 10 18 10C17.4477 10 17 10.4477 17 11C17 11.5523 17.4477 12 18 12Z"
                stroke="#A6A6A6"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M18 26C18.5523 26 19 25.5523 19 25C19 24.4477 18.5523 24 18 24C17.4477 24 17 24.4477 17 25C17 25.5523 17.4477 26 18 26Z"
                stroke="#A6A6A6"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_549_8016">
                <rect width="36" height="36" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
<script>
export default {
    name: "more-dots-button",
};
</script>
